import { addEmailWorkFlow } from "../../../../../actions/Utilities/EmailWorkFlow";
import { useMutation } from "react-query";
const useAddEmailWorkFlow = () => {
  return useMutation(addEmailWorkFlow);
};
export default useAddEmailWorkFlow;
